/* eslint-disable no-underscore-dangle */
import dayjs from 'dayjs';
import type { FC } from 'react';
import { useCallback, useEffect, useRef, useState } from 'react';
import { TextField } from '@/DesignSystem/Component';
import type { IFieldProps } from '@/DesignSystem/Model/DataModel';
import type { IDatepickerIImperativeHandleResult } from '@/Module/Auth/Model/DataModel';
import DatepickerDrawer from './DatepickerDrawer';
interface IDatepickerInputProps extends IFieldProps {
  setFormValue: (value: Date) => void;
}
const DatepickerInput: FC<IDatepickerInputProps> = ({
  control,
  name,
  setFormValue,
  ...props
}) => {
  const [isOpen, setOpen] = useState(false);
  const ref = useRef<IDatepickerIImperativeHandleResult>(null);
  const renderedValue = useCallback((value: Date) => {
    if (!value) return undefined;
    return dayjs(value).calendar('jalali').format('YYYY-MM-DD');
  }, []);
  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        ref.current?.setDate(control._formValues[name]);
      }, 200);
      return;
    }
    if (!ref.current) return;
    setFormValue(ref.current.getDate());
  }, [isOpen, ref.current]);
  return <>
      <TextField name={name} control={control} readOnly onClick={() => setOpen(true)} renderValue={renderedValue} {...props} data-sentry-element="TextField" data-sentry-source-file="DatepickerInput.tsx" />
      <DatepickerDrawer datepickerRef={ref} isOpen={isOpen} setOpen={setOpen} data-sentry-element="DatepickerDrawer" data-sentry-source-file="DatepickerInput.tsx" />
    </>;
};
export default DatepickerInput;